import { Program } from 'src/legacy/models/firebase'
import { useFirebase } from 'src/firebase'

export default function useLoadProgram(programID: string) {
  return useFirebase<Program>(`programs/${programID}`)
}
